import React, { useEffect, useState } from 'react'
import { calcularEdad, fechaActual } from '../../../hooks/UseDate';
import ModalValidarQuirofano from '../cambioDeEstado/ModalValidarQuirofano';
import ModalCirugia from '../../ModalCirugia';
import ModalAgregarPaquetesQuirurgicos from '../modalProcedimiento/ModalAgregarPaquetesQuirurgicos';
import ModalValidarButtonModificarProgramacionCirugia from '../../ModalValidarButtonModificarProgramacionCirugia';
import ModalConsentimientoInformado from '../../../pages/ModalConsentimientoInformado';
import CambioDeEstadoReservado from '../cambioDeEstado/CambioDeEstadoReservado';
import NovedadesAdministrativas from '../novedadesAdministrativas/NovedadesAdministrativas';
import CambioDeEstadoCancelar from '../cambioDeEstado/CambioDeEstadoCancelar';
import ModalConsentimientoInformacionCirugiaPrincipal from '../modalCirugia/ModalConsentimientoInformacionCirugiaPrincipal';

const TablaReservarCX = (props) => {
    const [modalOn, setModalOn] = useState(false);
    const [choice, setChoice] = useState(false)
    const [modalOnCambioEstadoReservado, setmodalOnCambioEstadoReservado]=useState(false)
    const [modalOnModificarButton, setmodalOnModificarButton]=useState(false)
    const [validarQuirofano, setvalidarQuirofano]=useState(false)
    const [modalOnAgregarPaquetesQuirurgicos,setmodalOnAgregarPaquetesQuirurgicos]=useState(false)
    const [modalOnConsentimientoInformado, setmodalOnConsentimientoInformado]=useState(false)
    const [actualizarTable, setactualizarTable]=useState([])
    const [novedadesAdministra, setnovedadesAdministra]=useState(false)
    const [modalOnCambioEstadoCancelado, setmodalOnCambioEstadoCancelado]= useState(false)

    const [diseableCambioEstado, setdiseableCambioEstado]=useState({
        estadoPaciente:'6',
        disabledPendiente:false,
        disabledReservado:false,
        disabledConfirmado:false,
        disabledIngresoSala:false,
        disabledPreparado:false,
        disabledCirugia:false,
        disabledRecuperacion:false,
        disabledSalida:false,
        disabledCancelar:false,
        disabledRealizada:false,
        disabledFacturada:false
      })


    useEffect(()=>{
        if(parseInt(props.user.ProEsta) === 6){
            setdiseableCambioEstado({
              estadoPaciente:'6',
              disabledPendiente:true,
              disabledReservado:false,
              disabledConfirmado:true,
              disabledIngresoSala:true,
              disabledPreparado:true,
              disabledCirugia:true,
              disabledRecuperacion:true,
              disabledSalida:true,
              disabledCancelar:false,
              disabledRealizada:true,
              disabledFacturada:true
            })            
        }else if(parseInt(props.user.ProEsta) === 1){
            setdiseableCambioEstado({
                estadoPaciente:'1',
                disabledPendiente:true,
                disabledReservado:true,
                disabledConfirmado:true,
                disabledIngresoSala:true,
                disabledPreparado:true,
                disabledCirugia:true,
                disabledRecuperacion:true,
                disabledSalida:true,
                disabledCancelar:false,
                disabledRealizada:true,
                disabledFacturada:true
          })
        }else if(parseInt(props.user.ProEsta) === 3){
          setdiseableCambioEstado({
            estadoPaciente:'3',
            disabledPendiente:true,
            disabledReservado:true,
            disabledConfirmado:true,
            disabledIngresoSala:true,
            disabledPreparado:true,
            disabledCirugia:true,
            disabledRecuperacion:true,
            disabledSalida:true,
            disabledCancelar:true,
            disabledRealizada:true,
            disabledFacturada:true,
            disabledReprogramar:true
          })
        }
    },[actualizarTable,props.user.ProCirCod])

    const handleState= (e)=>{
        e.preventDefault();
        //validacion si el quirofano no esta entonces abre un modal, si esta el quirofano abre un modal para cambiar el estado
        const { ConsDet } = props.user;
        const targetValueIsOne = e.target.value === '1';
        if(targetValueIsOne) {
            const consDetIsEmpty = ConsDet === null || ConsDet === '';        
            if(consDetIsEmpty) {
                setvalidarQuirofano(true);
            } else {
                setmodalOnCambioEstadoReservado(true);
            }
        }

        if(parseInt(e.target.value) === 3){
          setmodalOnCambioEstadoCancelado(true)
        }
    }

    //modificar una cirugia
    const modificar = ()=>{  
        if(parseInt(props.user.ProEsta) === 4){
          setmodalOnModificarButton(true)
        }else{
          setModalOn(true)
        }
          
    }

    //paquetes de cirugia
    const handleOnclickPaquetesQx=()=>{
        //setmodalOnPaquetesQx(true)
        if(parseInt(props.user.ProEsta) === 4){
          setmodalOnModificarButton(true)
        }else{
          setmodalOnAgregarPaquetesQuirurgicos(true)
        }
        
      }

      //actualizar tablar de procedimiento
      const passActualizarTablaProcedimiento=(data)=>{
        setactualizarTable(data)
      }
      //consentimiento informado para que firme el paciente
      const handleClickConsentimientoInformado=()=>{
        setmodalOnConsentimientoInformado(true)
      }

      //
      const passChildCambioDeEstado=(data)=>{
        setdiseableCambioEstado(data)
      }

      //novedades administrativas
      const handleOnClickNovedadesAdministrativas=()=>{
        setnovedadesAdministra(true)
      }

      //validar color
      const isTimeValidAndGreater=(hora)=>{
        // Define una expresión regular que representa el formato de hora esperado (HH:MM)
        const defaultTime = '00:00';
        let startTime = defaultTime;
        const timeFormat = /\d{2}:\d{2}/;
        
        // Si la hora de inicio sin procesar cumple con el formato de hora, divídela y úsala
        if (timeFormat.test(hora)) {
          let splitTime = hora.split(':');
          startTime = `${splitTime[0]}:${splitTime[1]}`;
          //console.log(startTime,'HORA INICIO')
          //validar hora actual
          const currentLocalTime = new Date().toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });
          let fechaIni=props.user.ProFec? props.user.ProFec.split(' ')[0]:null
          if((startTime < currentLocalTime) && (fechaActual() === fechaIni )){
              //setHoraInicialUserError('Hora Inicial no puede ser menor a la Hora Actual')
              return true
          }else{
            return false
          }
      }else{
        return false
      }
      }

  return (
    <>
         <tbody >
        <tr className={(props.user.cantidadProcedimientos > 1)?"divide-y divide-slate-700 bg-[#a7f3d0]":"divide-y divide-slate-700 "}>
          <td></td>
          <td className="text-xs text-gray-900 font-medium   whitespace-pre-wrap">
            <div className="pt-2 w-32 ">
              <div className="mb-3 xl:w-96">
                <select onChange={handleState} value={diseableCambioEstado.estadoPaciente} className="form-select block w-30 px-2 py-1.5 text-base font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat
                  border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" 
                  aria-label="Default select example">
                    <option value="6" disabled={diseableCambioEstado.disabledPendiente}>Pendiente</option>
                    <option value="1" disabled={diseableCambioEstado.disabledReservado}>Reservado</option>
                    <option value="3" disabled={diseableCambioEstado.disabledCancelar}>Cancelada</option>
                    
                </select>
              </div>
            </div>
          </td>
          <td className="text-xs text-gray-900 font-medium px-1 py-2 whitespace-pre-wrap">
          <button
              onClick={handleOnClickNovedadesAdministrativas}
              //disabled={false}
              type="button"
              className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 5C7 5 2.73 8.82 1.5 12.5c1.23 3.68 5.5 7.5 10.5 7.5s9.27-3.82 10.5-7.5C21.27 8.82 17 5 12 5z"></path>
  <circle cx="12" cy="12.5" r="3" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"></circle>
</svg>

            </button>
          </td>
          <td className="text-xs text-gray-900 font-medium px-1 py-2 whitespace-pre-wrap">
            <div className="">
              {parseInt(props.user.ProEsta) !== 3?
              <button
              onClick={modificar}
              //disabled={false}
              type="button"
              className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
            >
              Modificar
            </button>:
            null  
            }
                    
            </div>
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            {props.user.ProEsta != '3'?
            <button
            onClick={handleOnclickPaquetesQx}
            type="button"
            className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
          >
            Paquetes
          </button>:
          null
          }
                    
            
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
          <button
                      onClick={handleClickConsentimientoInformado}
                      type="button"
                      className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                    >
                      Consentimiento
                    </button>
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {props.user.ProCirCod? props.user.ProCirCod:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {props.user.MPTDoc? props.user.MPTDoc:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {props.user.MPCedu? props.user.MPCedu:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 text-left whitespace-pre-wrap ">
          <div className='flex '>
            {props.user.MPNOMC? props.user.MPNOMC:null }

            {
              props.user.PrcMulDsc? (props.user.PrcMulDsc.trim() === "PROGRAMADA"? 
              <div className="ml-2 h-6 w-6 rounded-full bg-blue-300 flex justify-center items-center text-blue-800">
  <svg viewBox="0 0 24 24" className="h-6 w-6">
    <text x="50%" y="50%" fill="currentColor" font-size="20" text-anchor="middle" alignment-baseline="central">P</text>
  </svg>
</div>
:
(props.user.PrcMulDsc.trim() === "URGENCIAS"? 
<div className="ml-2 h-6 w-6 rounded-full bg-red-300 flex justify-center items-center text-red-800">
  <svg viewBox="0 0 24 24" className="h-6 w-6">
    <text x="50%" y="50%" fill="currentColor" font-size="20" text-anchor="middle" alignment-baseline="central">U</text>
  </svg>
</div> 
:
(props.user.PrcMulDsc.trim() === "AMBULATORIA"? 
<div className="ml-2 h-6 w-6 rounded-full bg-blue-400 flex justify-center items-center text-blue-800">
  <svg viewBox="0 0 24 24" className="h-6 w-6">
    <text x="50%" y="50%" fill="currentColor" font-size="20" text-anchor="middle" alignment-baseline="central">A</text>
  </svg>
</div> 
:
null
)
)

              ) :null
            }
            
            
 
</div>


          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {props.user.ProFec? props.user.ProFec.split(' ')[0]:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            {props.user.CrgDes? props.user.CrgDes:null}
          </td>          
          <td className={`  justify-center items-center font-medium px-3 py-2 whitespace-pre-wrap  ${isTimeValidAndGreater(props.user.ProHorI) ? 'text-red-500 text-xl' : 'text-gray-900 text-xs'}`}>
            <div className='flex '>
            {props.user.ProHorI !== "  :  :  " ? props.user.ProHorI:null}
            {props.user.ProHorI? (isTimeValidAndGreater(props.user.ProHorI) ?
              // <div className="ml-2  h-6 w-6 rounded-full bg-red-300  ">
              //   <svg fill="currentColor" viewBox="0 0 20 20" className="h-6 w-6">
              //     <path
              //       fillRule="evenodd"
              //       d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              //       clipRule="evenodd"
              //     ></path>
              //   </svg>
              // </div>
              <div className='ml-2'> 
              <svg className="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 21" style={{ color: 'red' }}>
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 3.464V1.1m0 2.365a5.338 5.338 0 0 1 5.133 5.368v1.8c0 2.386 1.867 2.982 1.867 4.175C17 15.4 17 16 16.462 16H3.538C3 16 3 15.4 3 14.807c0-1.193 1.867-1.789 1.867-4.175v-1.8A5.338 5.338 0 0 1 10 3.464ZM4 3 3 2M2 7H1m15-4 1-1m1 5h1M6.54 16a3.48 3.48 0 0 0 6.92 0H6.54Z"/>
</svg>
</div>

              
            : null) : null} 
            
            </div> 
            
          </td>
<td className={` font-medium px-3 py-2 whitespace-pre-wrap text-left ${isTimeValidAndGreater(props.user.ProHorI) ? 'text-red-500 text-xl' : 'text-gray-900 text-xs'}`}>
            {props.user.ProHorF? props.user.ProHorF:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            {props.user.MPTele?props.user.MPTele:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            {props.user.ConsDet? props.user.ConsDet:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            {props.user.MPFchN? calcularEdad(props.user.MPFchN.split(' ')[0]):null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left ">
            {props.user.MENOMB? props.user.MENOMB:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left ">
            {props.user.camaUsuario? props.user.camaUsuario:null}
          </td>
        </tr>     
        </tbody>
        {modalOn && < ModalCirugia setModalOn={setModalOn} setChoice={setChoice} user={props.user} passDataActualizaTablaPacientes={props.passDataActualizaTablaPacientes}/>} 
        {validarQuirofano? <ModalValidarQuirofano setvalidarQuirofano={setvalidarQuirofano}/>:null}
        {modalOnAgregarPaquetesQuirurgicos? <ModalAgregarPaquetesQuirurgicos setmodalOnAgregarPaquetesQuirurgicos={setmodalOnAgregarPaquetesQuirurgicos} idCirugia={props.user.ProCirCod} user={props.user} passActualizarTablaProcedimiento={passActualizarTablaProcedimiento}/>:null}
        {modalOnModificarButton? <ModalValidarButtonModificarProgramacionCirugia setmodalOnModificarButton={setmodalOnModificarButton}/>:null}
        {/* {modalOnConsentimientoInformado? <ModalConsentimientoInformado setmodalOnConsentimientoInformado={setmodalOnConsentimientoInformado} user={props.user}/>:null} */}
        {modalOnConsentimientoInformado? <ModalConsentimientoInformacionCirugiaPrincipal setmodalOnConsentimientoInformado={setmodalOnConsentimientoInformado} user={props.user}/>:null}
        {modalOnCambioEstadoReservado? <CambioDeEstadoReservado setmodalOnCambioEstadoReservado={setmodalOnCambioEstadoReservado} user={props.user} passActualizarTablaProcedimiento={passActualizarTablaProcedimiento}  passChildCambioDeEstado={passChildCambioDeEstado}/>:null}  
        {novedadesAdministra? <NovedadesAdministrativas setnovedadesAdministra={setnovedadesAdministra} user={props.user}/>:null}
        {modalOnCambioEstadoCancelado? <CambioDeEstadoCancelar setmodalOnCambioEstadoCancelado={setmodalOnCambioEstadoCancelado} user={props.user} passDataActualizaTablaPacientes={props.passDataActualizaTablaPacientes}/>:null}
        </>
  )
}

export default TablaReservarCX